<template>
  <div class="table-responsive">
    <WCSpinner v-if="loading" position="center" size="xl" />
    <table class="table table-striped table-border table-hover table-condensed">
      <tr>
        <th>{{ $t('commands') }}</th>
        <th>{{ $t('customerId') }}</th>
        <th>{{ $t('alias') }}</th>
        <th>{{ $t('firstName') }}</th>
        <th>{{ $t('lastName') }}</th>
        <th>{{ $t('company') }}</th>
        <th>{{ $t('emailAddress') }}</th>
        <th>{{ $t('phoneNumber') }}</th>
      </tr>
      <tr v-for="customer in customers" :key="customer.id">
        <td>
          <button
            class="btn btn-primary"
            @click="associate(customer.id)"
            :disabled="customer.id == user.sub"
          >
            {{ $t('associate') }}
          </button>
        </td>
        <td>{{ customer.accountNumber }}</td>
        <td>{{ customer.alias }}</td>
        <td>{{ customer.firstName }}</td>
        <td>{{ customer.lastName }}</td>
        <td>{{ customer.company }}</td>
        <td>
          <div v-for="email in customers.email" :key="email.id">{{ customer.email }}</div>
        </td>
        <td>
          <div v-for="phone in customers.phone" :key="phone.id">{{ customer.phone }}</div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';

export default {
  components: { WCSpinner },
  name: 'WCCustomerTable',
  data() {
    return {
      isActive: true,
      loading: false,
    };
  },
  props: {
    customers: Array,
    user: {
      type: Object,
      required: false,
    },
  },
  methods: {
    ...mapActions({
      reloadCart: 'cart/reload',
    }),
    async associate(id) {
      try {
        this.loading = true;
        await axios.post(`/api/employee/cs`, { id });
        this.reloadCart();
        this.isActive = false;
        this.$router.push({
          name: 'Home',
        });
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'success',
            title: 'Customer Association',
            message: 'You have successfully been associated',
          },
          timeout: 7000,
        });
      } catch (error) {
        console.error(error);
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: 'Error',
            message: error,
          },
          timeout: 7000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
